module.exports = KalturaPlayer.core;